export default {
  common: {
    required: 'This is required',
    loginOut: 'Log out',
    document: 'Document',
    reminder: 'Reminder',
    loginOutMessage: 'Exit the system?',
    ok: 'OK',
    cancel: 'Cancel',
    reload: 'Reload current',
    closeTab: 'Close current',
    closeTheLeftTab: 'Close left',
    closeTheRightTab: 'Close right',
    closeOther: 'Close other',
    closeAll: 'Close all',
    scrollTagsLeft: 'Scroll tabs left',
    scrollTagsRight: 'Scroll tabs right',
    moreTabActions: 'More tab actions',
    search: 'Search',
    reset: 'Reset',
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    actions: 'Actions',
    confirm: 'Confirm',
    confirmDelete: 'Are you sure to delete {name}?',
    submit: 'Submit',
    submitSuccess: 'Operation succeeded',
    submitFailed: 'Operation failed',
    loading: 'Loading...',
    noData: 'No data',
    refresh: 'Refresh',
    selected: '{count} selected',
    close: 'Close'
  },
  picker: {
    checkedCount: '{count} selected'
  },
  error: {
    pageError: 'Sorry, the page you visited does not exist.',
    returnToHome: 'Return to home'
  },
  layout: {
    title: 'Page layout',
    hint: 'Applies immediately',
    switch: 'Switch page layout',
    sidebar: 'Sidebar',
    top: 'Top navigation',
    mixed: 'Mixed navigation',
    dual: 'Dual sidebar',
    expandNavigation: 'Expand navigation',
    collapseNavigation: 'Collapse navigation'
  },
  login: {
    welcome: 'Welcome to the system',
    message: 'Backstage management system',
    username: 'Username',
    password: 'Password',
    register: 'Register',
    checkPassword: 'Confirm password',
    login: 'Sign in',
    remember: 'Remember me',
    hasUser: 'Existing account? Go to login',
    usernamePlaceholder: 'Please input username',
    passwordPlaceholder: 'Please input password',
    code: 'Verification code',
    codePlaceholder: 'Please input verification code',
    getCode: 'Get code',
    passwordMismatch: 'The passwords do not match',
    agreement: 'I agree to the User Agreement',
    agreementRequired: 'Please accept the User Agreement',
    phone: 'Phone',
    phonePlaceholder: 'Please input phone number',
    phoneLength: 'Phone must be 6-20 characters',
    passwordLength: 'Password must be 6-128 characters',
    failed: 'Sign in failed. Check phone and password.'
  },
  router: {
    login: 'Login',
    dashboard: 'Dashboard',
    level: 'Multi-level menu',
    menu1: 'Menu1',
    menu11: 'Menu1-1',
    menu111: 'Menu1-1-1',
    menu12: 'Menu1-2',
    menu2: 'Menu2',
    system: 'System',
    systemUsers: 'Users',
    systemRoles: 'Roles',
    systemPermissions: 'Permissions',
    teaching: 'Teaching',
    teachingCourses: 'Courses',
    teachingSkills: 'Skills',
    teachingAssets: 'Assets',
    qa: 'Q&A',
    qaRecords: 'Q&A records'
  },
  resource: {
    codePattern:
      'Use lowercase letters, digits and underscores, with at least one dot (e.g. aaa.bbb)'
  },
  permission: {
    code: 'Code',
    name: 'Name',
    description: 'Description',
    keywordPlaceholder: 'Search by code or name',
    codePlaceholder: 'e.g. user.read',
    namePlaceholder: 'Please input name',
    descriptionPlaceholder: 'Optional description',
    create: 'Create permission',
    edit: 'Edit permission'
  },
  role: {
    code: 'Code',
    name: 'Name',
    description: 'Description',
    builtin: 'Built-in',
    builtinTip: 'Built-in roles cannot be edited or deleted',
    assignPermissions: 'Assign permissions',
    keywordPlaceholder: 'Search by code or name',
    permissionCodes: 'Permission codes',
    create: 'Create role',
    edit: 'Edit role',
    roleId: 'Role ID',
    roleList: 'Role list'
  },
  userRole: {
    title: 'User roles',
    userId: 'User ID',
    userIdRequired: 'Please input a user ID',
    roleNames: 'Assigned roles',
    permissionCodes: 'Effective permission codes',
    assignRole: 'Assign roles',
    noData: 'Enter a user ID and search first'
  },
  user: {
    username: 'Username',
    usernamePlaceholder: '1-64 characters',
    usernameLength: 'Username must be 1-64 characters',
    password: 'Password',
    passwordPlaceholder: '6-128 characters',
    newPassword: 'New password',
    phone: 'Phone',
    phonePlaceholder: 'Optional phone',
    nickname: 'Nickname',
    nicknamePlaceholder: 'Optional nickname',
    businessRole: 'Business role',
    businessRolePlaceholder: 'Select a business role',
    isAdmin: 'Backend admin',
    isAdminHint: 'Allow backend sign-in',
    isAdminAllow: 'Allowed',
    isAdminDeny: 'Forbidden',
    roleSuperAdmin: 'Super admin',
    roleTeacher: 'Teacher',
    roleStudent: 'Student',
    isAdminFilter: 'Admins only',
    keywordPlaceholder: 'Search by username / phone / nickname',
    create: 'Create user',
    edit: 'Edit user',
    resetPassword: 'Reset password',
    deleteSelfForbidden: 'You cannot delete your own account',
    confirmDelete: 'Are you sure to delete user {name}?'
  },
  profile: {
    title: 'Profile',
    userId: 'User ID',
    username: 'Name',
    nickname: 'Nickname',
    phone: 'Phone',
    changePassword: 'Change password',
    oldPassword: 'Current password',
    oldPasswordPlaceholder: 'Leave blank if unset',
    newPassword: 'New password',
    newPasswordPlaceholder: '6-128 characters',
    confirmPassword: 'Confirm new password',
    confirmPasswordPlaceholder: 'Re-enter the new password',
    passwordMismatch: 'The two passwords do not match',
    passwordChanged: 'Password updated'
  },
  course: {
    title: 'Courses',
    name: 'Course name',
    namePlaceholder: 'Please input course name',
    nameLength: 'Course name must be 1-128 characters',
    subject: 'Subject',
    subjectPlaceholder: 'Select a subject',
    gradeScope: 'Grades',
    gradeScopePlaceholder: 'Pick one or more (empty means all)',
    gradeScopePattern: 'Grade scope must look like X-Y where 1<=X<=Y<=12',
    gradesRequired: 'Please select at least one grade',
    description: 'Description',
    descriptionPlaceholder: 'Within 200 characters',
    descriptionLength: 'Description must be 200 characters or less',
    status: 'Status',
    statusPlaceholder: 'Select a status',
    sortOrder: 'Sort order',
    sortOrderPlaceholder: 'Ascending among siblings; smaller goes first',
    parent: 'Parent course',
    parentPlaceholder: 'Leave empty for a root course',
    parentNone: '(root course)',
    createRoot: 'New root course',
    addChild: 'New child',
    addSibling: 'New sibling',
    changeParent: 'Change parent',
    changeSort: 'Change sort',
    changeStatus: 'Disable',
    enableStatus: 'Enable',
    subjectAll: 'All subjects',
    statusAll: 'All statuses',
    statusDraft: 'Draft',
    statusTrial: 'Trial',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    cascadeTip: 'Disabling this course cascades to all descendants',
    deleteCascadeTip: 'Deleting cascades to all descendants (soft delete)',
    confirmDeleteCascade: 'Delete "{name}" and all descendants? This cannot be undone.',
    hasChildren: 'This course has {count} child course(s)',
    setSkills: 'Set skills',
    setSkillsTitle: 'Set skills for "{name}"',
    setSkillsHint: 'Tick the skills to associate with this course (replaces all existing links)',
    skillsKeywordPlaceholder: 'Search by skill name'
  },
  skill: {
    title: 'Skills',
    name: 'Skill name',
    namePlaceholder: 'Please input skill name',
    nameLength: 'Skill name must be 1-128 characters',
    subject: 'Subject',
    subjectPlaceholder: 'Select a subject',
    module: 'Module',
    modulePlaceholder: 'Within 20 characters; optional',
    description: 'Description',
    descriptionPlaceholder: 'Within 200 characters',
    descriptionLength: 'Description must be 200 characters or less',
    status: 'Status',
    statusPlaceholder: 'Select a status',
    sortOrder: 'Sort order',
    sortOrderPlaceholder: 'Ascending among siblings; smaller goes first',
    parent: 'Parent skill',
    parentPlaceholder: 'Leave empty for a root skill',
    parentNone: '(root skill)',
    createRoot: 'New root skill',
    addChild: 'New child',
    addSibling: 'New sibling',
    changeParent: 'Change parent',
    changeSort: 'Change sort',
    changeStatus: 'Disable',
    enableStatus: 'Enable',
    subjectAll: 'All subjects',
    statusAll: 'All statuses',
    statusDraft: 'Draft',
    statusTrial: 'Trial',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    cascadeTip: 'Disabling this skill cascades to all descendants',
    deleteCascadeTip: 'Deleting cascades to all descendants (soft delete)',
    confirmDeleteCascade: 'Delete "{name}" and all descendants? This cannot be undone.',
    hasChildren: 'This skill has {count} child skill(s)',
    setCourses: 'Set courses',
    setCoursesTitle: 'Set courses for "{name}"',
    setCoursesHint: 'Tick the courses to associate with this skill (replaces all existing links)',
    coursesKeywordPlaceholder: 'Search by course name'
  },
  analysis: {
    newUser: 'New user',
    unreadInformation: 'Unread information',
    transactionAmount: 'Transaction amount',
    totalShopping: 'Total shopping',
    monthlySales: 'Monthly sales',
    userAccessSource: 'User access source',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    estimate: 'Estimate',
    actual: 'Actual',
    directAccess: 'Direct access',
    mailMarketing: 'Mail marketing',
    allianceAdvertising: 'Alliance advertising',
    videoAdvertising: 'Video advertising',
    searchEngines: 'Search engines',
    weeklyUserActivity: 'Weekly user activity',
    activeQuantity: 'Active quantity',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday'
  },
  levelDemo: {
    menu: 'Multi-level menu cache'
  },
  asset: {
    title: 'Assets',
    name: 'Asset name',
    assetType: 'Asset type',
    assetTypeAll: 'All asset types',
    assetTypePlaceholder: 'Select an asset type',
    fileType: 'File type',
    fileTypeAll: 'All file types',
    fileTypePlaceholder: 'Select a file type',
    status: 'Status',
    statusAll: 'All statuses',
    statusPlaceholder: 'Select a status',
    nameKeyword: 'Keyword',
    nameKeywordPlaceholder: 'Search by asset name',
    dateRange: 'Upload time',
    fileSize: 'Size',
    fileSizeBytes: '{size} bytes',
    originalFilename: 'Original filename',
    uploadedAt: 'Uploaded at',
    description: 'Description',
    descriptionPlaceholder: 'Within 200 characters',
    create: 'New asset',
    edit: 'Edit asset',
    upload: 'Upload',
    bulkUpload: 'Bulk upload',
    bulkUploadHint: 'Select multiple files; they will be imported under the same asset type',
    bulkChangeStatus: 'Bulk change status',
    changeStatus: 'Disable',
    enableStatus: 'Enable',
    download: 'Download',
    detail: 'View detail',
    delete: 'Delete',
    deleteConfirm: 'Delete "{name}"?',
    deleteCascadeTip: 'This cannot be undone',
    selectFiles: 'Select files',
    fileChosen: '{count} file(s) selected',
    noFileChosen: 'No file chosen',
    submitHint: 'Import under the chosen asset type & status',
    assetTypesLoading: 'Loading asset types…',
    setCourses: 'Set courses',
    setSkills: 'Set skills',
    bulkSetCourses: 'Bulk set courses',
    bulkSetSkills: 'Bulk set skills',
    setCoursesTitle: 'Set courses for "{name}"',
    setSkillsTitle: 'Set skills for "{name}"',
    bulkSetCoursesTitle: 'Set courses for {count} assets',
    bulkSetSkillsTitle: 'Set skills for {count} assets',
    assignHint: 'Replace-all: only checked items are kept; uncheck all to clear',
    statusDraft: 'Draft',
    statusTrial: 'Trial',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    cascadeTip: 'Disabling takes effect immediately (no cascade)'
  },
  qa: {
    title: 'Q&A records',
    dateRange: 'Session time',
    userName: 'User name',
    userNamePlaceholder: 'Search by nickname / username',
    sessionTitle: 'Session title',
    sessionTitlePlaceholder: 'Search by session title',
    user: 'User',
    messageCount: 'Messages',
    createdAt: 'Created at',
    lastActiveAt: 'Last active',
    detail: 'View detail',
    empty: 'No Q&A records',
    detailTitle: 'Q&A session detail',
    untitled: '(untitled)',
    roleUser: 'Student',
    roleAssistant: 'AI assistant',
    roleSystem: 'System',
    kbRefs: 'Knowledge base refs',
    kbRefUnknown: 'Unknown document',
    kbRefNoSummary: '(no summary)',
    noMessages: 'No messages in this session'
  }
}
